import React, { PureComponent } from 'react';

import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { object } from '@philips-emr/tws-core/lib/component/prop-types';

import './custom-html.scss';

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY })
export default class CustomHtml extends PureComponent {

  static propTypes = {
    data: object.notEnumerable(),
  }

  render() {
    return (
      <div className="c-text-html__value c-custom-text-black">
        <div className="c-text-html__value--width"
          dangerouslySetInnerHTML={{ __html: this.props.data }}></div>
      </div>
    );
  }
}
